import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    let corumProfiles: UntypedFormGroup[] = [];
    const currentCorumProfiles = entity?.parameters?.corumProfiles || [];

    if (currentCorumProfiles)
      _.forEach(currentCorumProfiles, (support, i) =>
        corumProfiles.push(
          this.formBuilder.group(this.createModel(support, entity)),
        ),
      );

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        operation: [entity?.parameters?.operation || 'SUBSCRIPTION'],
        vlAmount: [
          !['VERSEMENT_COMPLEMENTAIRE', 'VERSEMENT_PROGRAMME'].includes(
            entity?.parameters?.operation,
          )
            ? 0
            : entity?.parameters?.supportsInvestment?.totalAmount || 0,
        ],
        avInitialPayment: [
          entity?.parameters?.avInvestmentType === 'MONTHLY' ||
          entity?.parameters?.operation !== 'SUBSCRIPTION'
            ? 0
            : entity?.parameters?.avInitialPayment || 0,
        ],
        avMonthlyPayment: [
          entity?.parameters?.avInvestmentType === 'INITIAL' ||
          entity?.parameters?.operation !== 'SUBSCRIPTION'
            ? 0
            : entity?.parameters?.avMonthlyPayment || 0,
        ],
        corumProfiles: this.formBuilder.array(
          corumProfiles,
          Validators.required,
        ),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  public createModel(item, entity) {
    return {
      label: [item ? item.label : null],
      isin: [item ? item.isin : null],
      percentage: [
        item && !_.isNil(item.percentage) ? item.percentage : 0,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
    };
  }

  get arbitrageType(): string {
    return this.form
      .get('products')
      .get(`${0}`)
      .get('parameters')
      .get('arbitrageType').value;
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get corumProfiles() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('corumProfiles') as UntypedFormArray;
  }

  get formattedInvestmentLabel() {
    const operation = this.products
      .get(`${0}`)
      .get('parameters')
      .get('operation').value;

    const vlAmount = this.products
      .get(`${0}`)
      .get('parameters')
      .get('vlAmount').value;

    const avInitialPayment = this.products
      .get(`${0}`)
      .get('parameters')
      .get('avInitialPayment').value;

    const avMonthlyPayment = this.products
      .get(`${0}`)
      .get('parameters')
      .get('avMonthlyPayment').value;

    if (operation === 'VERSEMENT_COMPLEMENTAIRE') {
      return `Versement complémentaire de ${vlAmount} €`;
    } else if (operation === 'VERSEMENT_PROGRAMME') {
      return `Versement programmé de ${vlAmount} €`;
    } else if (operation === 'SUBSCRIPTION') {
      if (avInitialPayment > 0 && avMonthlyPayment > 0) {
        return `Versement initial de ${avInitialPayment} € et versement programmé de ${avMonthlyPayment} €`;
      } else if (avInitialPayment > 0) {
        return `Versement initial de ${avInitialPayment} €`;
      } else if (avMonthlyPayment > 0) {
        return `Versement programmé de ${avMonthlyPayment} €`;
      }
    }
  }

  extract() {
    const products = _.cloneDeep(this.form.value.products);
    return products;
  }
}
